export default __webpack_public_path__ + "static/media/N2.3d641970.png";